import React from 'react'

import { HStack } from '~/components/elements/HStack'

import { type StrategyMemo } from '../hooks/useStrategyMemosInfiniteQuery'

import { ArchiveButton } from './ArchiveButton'
import { CloneButton } from './CloneButton'
import { ShareButton } from './ShareButton'

export type CommandsCellProps = {
  dataItem: StrategyMemo
}

export const CommandsCell = ({ dataItem: strategyMemo }: CommandsCellProps) => (
  <td>
    <HStack backgroundColor="transparent" spacing={1}>
      <ShareButton strategyMemo={strategyMemo} />

      <CloneButton strategyMemo={strategyMemo} />

      <ArchiveButton strategyMemo={strategyMemo} />
    </HStack>
  </td>
)
